import React from 'react';
import PropTypes from 'prop-types';
import { IconClose } from 'svgIcons/MotionPortalIcons';
import SignalLegendItem from './SignalLegendItem';

const TimestampGroup = ({
    timestamp,
    signals,
    visibleTimestampCount,
    selectedTimestamps,
    handleTimestampLegendClick,
    handleSignalClick,
    handleRemoveTimestamp
}) => {
    const isAnySignalVisible = signals.some(s => s.visible);

    return (
        <span className='legend-flex-row' key={timestamp}>
            <button
                type='button'
                className={`timestamp-legend-label${isAnySignalVisible ? '' : ' hidden'}`}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    if (visibleTimestampCount > 1) {
                        handleTimestampLegendClick(timestamp);
                    }
                }}
            >
                {timestamp}
            </button>
            {signals.map(s =>
                <SignalLegendItem
                    key={s.userOptions?.id || s.name}
                    signal={s}
                    timestamp={timestamp}
                    handleSignalClick={handleSignalClick}
                />
            )}
            {selectedTimestamps?.length > 1 &&
                <button type='button' className='close-icon' onClick={() => handleRemoveTimestamp(timestamp)}>
                    <IconClose />
                </button>
            }
        </span>
    );
};

TimestampGroup.propTypes = {
    timestamp: PropTypes.string.isRequired,
    signals: PropTypes.arrayOf(
        PropTypes.shape({
            visible: PropTypes.bool,
            userOptions: PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            }),
            name: PropTypes.string,
            color: PropTypes.string
        })
    ).isRequired,
    visibleTimestampCount: PropTypes.number.isRequired,
    selectedTimestamps: PropTypes.array.isRequired,
    handleTimestampLegendClick: PropTypes.func.isRequired,
    handleSignalClick: PropTypes.func.isRequired,
    handleRemoveTimestamp: PropTypes.func.isRequired
};

export default TimestampGroup;
